import { Button, InfoIcon } from '@hcs/design-system';

import styles from './PropertyTypeWarning.module.css';

interface PropertyTypeWarningProps {
  dataHcName: string;
  propertyType: 'singleFamily' | 'condo';
  setPropertyType?: (propertyType: 'singleFamily' | 'condo') => void;
  hideInteractive?: boolean;
}

export const PropertyTypeWarning = ({
  dataHcName,
  setPropertyType,
  propertyType,
  hideInteractive,
}: PropertyTypeWarningProps) => {
  const label = propertyType === 'condo' ? 'condo' : 'single family';
  const otherLabel = propertyType === 'condo' ? 'single family' : 'condo';

  return (
    <div className={styles.Warning}>
      <span className={styles.WarningIcon}>
        <InfoIcon size="md" />
      </span>
      <div className={styles.WarningText}>
        <b>Heads up.</b> You&apos;re viewing{' '}
        <span className={styles.WarningPropertyType}>{label}</span> data only.
        Summary, stats, and charts on this page reflect {label} comps
        {!hideInteractive &&
          ' — switch property type above to see the other segment'}
        .
      </div>
      {!hideInteractive && setPropertyType && (
        <Button
          dataHcName={dataHcName}
          onClick={() =>
            setPropertyType(propertyType === 'condo' ? 'singleFamily' : 'condo')
          }
          secondary
        >
          View {otherLabel} instead
        </Button>
      )}
    </div>
  );
};
